import React, { Component } from 'react';
import { translate } from 'react-i18next';

import Button from 'components/Button/Button';
import Warning from 'components/Warning/Warning';
import CheckBox from 'components/CheckBox/CheckBox';
import CustomModal from 'components/CustomModal/CustomModal';

import Utils from 'utils/Utils';
import RequestService from 'services/RequestService';
import { initSearchMap, getExtentByCoordinates, extentIntersectsBbox, setInitView } from 'utils/Visor';

import './Filters.css';

declare var CONFIGURATIONS;

class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchOption: this.props.searchOption,
      collections: this.props.collections,
      query: undefined,
      author: undefined,
      title: undefined,
      year_from: undefined,
      year_to: undefined,
      centuries: [],
      collectionsSelected: [this.props.searchOption],
      results: [],
      allResults: [],
      open: false,
      modalOption: undefined,
      searched: false,
      calculatedYearFrom: CONFIGURATIONS.first_year_seach,
      calculatedYearTo: new Date().getFullYear(),
    };

    this.filterFields = [
      'creator_user_id',
      'id',
      'metadata_created',
      'metadata_modified',
      'name',
      'organization',
      'owner_org',
      'spatial',
      'groups',
      'resources',
      'tags',
      'relationships_as_subject',
      'relationships_as_object',
    ];
  }

  componentDidMount() {
    if (this.props.searchOption !== 'cartografia-antigua') {
      initSearchMap();
    }

    document.querySelector('#queryText').addEventListener('keyup', this.enterKeySearch);
    document.querySelector('#authorText').addEventListener('keyup', this.enterKeySearch);
    document.querySelector('#titleText').addEventListener('keyup', this.enterKeySearch);
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({ collections: nextProps.collections });
  }

  componentWillMount() {
    this.loadInitResults();
  }

  loadInitResults = () => {
    const _this = this;
    _this.props.block();
    const url = `${CONFIGURATIONS.ckan_url}/package_search?fq=groups:${_this.props.searchOption}&rows=5000`;
    RequestService.getRequest(url).then((response) => {
      const results = response.result.results;
      _this.props.unblock();
      _this.props.updateResults(results);
      let yearFrom = 3000;
      let yearTo = 0;
      results.forEach((r) => {
        const innerYear = parseInt(r.date.substring(0, 4));
        if (yearFrom > innerYear) {
          yearFrom = innerYear;
        }

        if (yearTo < innerYear) {
          yearTo = innerYear;
        }
      });

      _this.setState({ results, allResults: results, calculatedYearFrom: yearFrom, calculatedYearTo: yearTo });
    }).catch((err) => {
      _this.props.unblock();
      _this.handleOpen('error-loading');
    });
  }

  onChangeFormField = (name, evt) => {
    let newState = this.state;
    const value = evt.target.value;
    newState[name] = value;
    this.setState(newState);
  }

  search = () => {
    const { query, author, title, year_from, year_to, centuries, collectionsSelected, allResults } = this.state;
    const _this = this;
    this.props.block();
    if (collectionsSelected.length >= 1 && collectionsSelected.indexOf('cartografia-antigua') === -1) {
      this.setState({ results: [] }, () => {
        _this.props.updateResults([]);
        const requests = [];
        collectionsSelected.forEach((c) => {
          requests.push(RequestService.getRequest(`${CONFIGURATIONS.ckan_url}/package_search?fq=groups:${c}&rows=5000`));
        });

        Promise.all(requests).then((responses) => {
          let results = [];
          let allResults = [];
          responses.forEach((response) => {
            results = results.concat(response.result.results);
            allResults = results.concat(response.result.results);
          });

          if (author !== undefined && author.length > 0) {
            results = results.filter((f) => {
              return Utils.stringContainsString(f.map_creator, author);
            });
          }

          if (title !== undefined && title.length > 0) {
            results = results.filter((f) => {
              return Utils.stringContainsString(f.title, title);
            });
          }

          if (query !== undefined && query.length > 0) {
            results = results.filter((f) => {
              let res = false;
              Object.keys(f).forEach((k) => {
                if (this.filterFields.indexOf(k) === -1 && Utils.stringContainsString(`${f[k]}`, query)) {
                  res = true;
                }
              });

              return res;
            });
          }

          results = results.filter((f) => {
            let res = false;
            const spatial = f.spatial;
            if (spatial.length !== 0) {
              const coordinates = JSON.parse(spatial);
              const extent = getExtentByCoordinates(coordinates);
              res = extentIntersectsBbox(extent);
            }

            return res;
          });

          this.setState({ results, allResults, searched: true }, () => {
            _this.props.updateResults(results);
            _this.props.unblock();
          });
        }).catch((err) => {
          _this.props.unblock();
          _this.clean();
          _this.handleOpen('error-loading');
        });
      });
    } else {
      let results = [].concat(allResults);
      if (centuries.length === 0 && year_from !== undefined && year_to !== undefined) {
  			results = results.filter((f) => {
          const year = parseInt(f.date.substring(0, 4), 10);
  				return year >= year_from && year <= year_to;
  			});
      } else if (centuries.length > 0) {
        let yearFrom = 0;
        let yearTo = 3000;
        centuries.forEach((c) => {
          if (c === 'century1') {
            if (yearFrom === 0 || yearFrom > 1601) {
              yearFrom = 1601;
            }

            if (yearTo === 3000 || yearTo < 1700) {
              yearTo = 1700;
            }
          } else if (c === 'century2') {
            if (yearFrom === 0 || yearFrom > 1701) {
              yearFrom = 1701;
            }

            if (yearTo === 3000 || yearTo < 1800) {
              yearTo = 1800;
            }
          } else if (c === 'century3') {
            if (yearFrom === 0 || yearFrom > 1801) {
              yearFrom = 1801;
            }

            if (yearTo === 3000 || yearTo < 1900) {
              yearTo = 1900;
            }
          } else if (c === 'century4') {
            if (yearFrom === 0 || yearFrom > 1901) {
              yearFrom = 1901;
            }

            if (yearTo === 3000 || yearTo < 2000) {
              yearTo = 2000;
            }
          }
        });

        results = results.filter((f) => {
          const year = parseInt(f.date.substring(0, 4), 10);
  				return year >= yearFrom && year <= yearTo;
  			});
      }

      if (author !== undefined && author.length > 0) {
        results = results.filter((f) => {
          return Utils.stringContainsString(f.map_creator, author);
        });
      }

      if (title !== undefined && title.length > 0) {
        results = results.filter((f) => {
          return Utils.stringContainsString(f.title, title);
        });
      }

      if (query !== undefined && query.length > 0) {
        results = results.filter((f) => {
          let res = false;
          Object.keys(f).forEach((k) => {
            if (['organization', 'groups', 'resources', 'tags', 'relationships_as_subject', 'relationships_as_object'].indexOf(k) === -1 && Utils.stringContainsString(`${f[k]}`, query)) {
              res = true;
            }
          });

          return res;
        });
      }

      this.setState({ results: results, searched: true }, () => {
        _this.props.updateResults(results);
        _this.props.unblock();
      });
    }
  }

  selectCentury = (century) => {
    let centuries = this.state.centuries;
    if (centuries.indexOf(century) > -1) {
      centuries = centuries.filter((c) => c !== century );
    } else {
      centuries.push(century);
    }

    this.setState({ centuries });
  }

  selectCollection = (collection) => {
    let collectionsSelected = this.state.collectionsSelected;
    if (collectionsSelected.indexOf(collection) > -1) {
      collectionsSelected = collectionsSelected.filter((c) => c !== collection);
    } else {
      collectionsSelected.push(collection);
    }

    this.setState({ collectionsSelected });
  }

  enterKeySearch = (evt) => {
    const keyCode = evt.charCode || evt.which;
    if (keyCode === 13) {
      this.search();
    }
  }

  clean = () => {
    const _this = this;
    this.props.block();
    if (this.props.searchOption !== 'cartografia-antigua') {
      setInitView();
    }

    if (this.state.collectionsSelected.length >= 1) {
      this.setState({
        query: '',
        author: '',
        title: '',
        year_from: undefined,
        year_to: undefined,
        centuries: [],
        collectionsSelected: [this.props.searchOption],
        results: this.state.allResults,
        searched: false,
      }, () => {
        _this.loadInitResults();
        document.getElementById('queryText').value = '';
        document.getElementById('authorText').value = '';
        document.getElementById('titleText').value = '';
      });
    } else {
      this.setState({
        query: '',
        author: '',
        title: '',
        year_from: undefined,
        year_to: undefined,
        centuries: [],
        collectionsSelected: [this.props.searchOption],
        results: this.state.allResults,
        searched: false,
      }, () => {
        _this.props.updateResults(this.state.allResults);
        _this.props.unblock();
        document.getElementById('queryText').value = '';
        document.getElementById('authorText').value = '';
        document.getElementById('titleText').value = '';
      });
    }
  }

  handleOpen = (modalOption) => {
    this.setState({ open: true, modalOption: modalOption });
  }

  handleClose = () => {
    this.setState({ open: false, modalOption: undefined });
  }

  render() {
    const { t, searchOption, collections } = this.props;
    const { query, author, title, year_from, year_to, open, modalOption, centuries, searched, calculatedYearFrom, calculatedYearTo, collectionsSelected } = this.state;
    const optionsFrom = [<option value='default' key='fromDefault'>{t('filters.select')}</option>];
    const optionsTo = [<option value='default' key='toDefault'>{t('filters.select')}</option>];
    const years = [];
    const collectionsRows = [];
    for (let i = calculatedYearFrom; i <= calculatedYearTo; i++) {
      years.push(i);
    }

    years.forEach((y) => {
      optionsFrom.push(<option key={'from' + y} value={y}>{y}</option>);
      if (year_from !== undefined && y >= year_from) {
        optionsTo.push(<option key={'to' + y} value={y}>{y}</option>);
      } else if (year_from === undefined) {
        optionsTo.push(<option key={'to' + y} value={y}>{y}</option>);
      }
    });

    collections.forEach((c) => {
      if (c.name !== 'cartografia-antigua') {
        collectionsRows.push(
          <div key={`collection_cb_${c.name}`} className='checkboxContainer'>
            <CheckBox id={c.name} onClick={this.selectCollection.bind(null, c.name)} isSelected={collectionsSelected.indexOf(c.name) > -1} />
            <span>{c.title}</span>
          </div>
        );
      }
    })

    return (
      <div className='filtersContainer'>
        <div className='filtersTitleContainer row'>
          <div className='title'>{'Filtros de búsqueda'}</div>
        </div>
        <div>
          <div className='filtersFormContainer row'>
            <table>
              <tbody>
                { searchOption !== 'cartografia-antigua' ?
                  <tr>
                    <td colSpan={2}>
                      <div id='searchMap'>
                      </div>
                    </td>
                  </tr>
                : null }
                <tr>
                  <td className='attribute-selector-field-title'>{'Cualquier campo'}</td>
                  <td className='attribute-selector-field-value'>
                    <input type='text' id='queryText' name='queryText' defaultValue={query} onChange={this.onChangeFormField.bind(null, 'query')} />
                  </td>
                </tr>
                <tr>
                  <td className='attribute-selector-field-title'>{'Autor (es) o entidad'}</td>
                  <td className='attribute-selector-field-value'>
                    <input type='text' id='authorText' name='authorText' defaultValue={author} onChange={this.onChangeFormField.bind(null, 'author')} />
                  </td>
                </tr>
                <tr>
                  <td className='attribute-selector-field-title'>{'Título'}</td>
                  <td className='attribute-selector-field-value'>
                    <input type='text' id='titleText' name='titleText' defaultValue={title} onChange={this.onChangeFormField.bind(null, 'title')} />
                  </td>
                </tr>
                { searchOption === 'cartografia-antigua' ?
                  <tr>
                    <td className='attribute-selector-field-title'>{'Fechas'}</td>
                    <td className='attribute-selector-field-value' style={{ display: 'flex', justifyContent: 'center' }}>
                      <select id='flightYearFrom' defaultValue={year_from || 'default'} onChange={this.onChangeFormField.bind(null, 'year_from')} style={{ minWidth: '80px', marginRight: '10px' }}>
                        {optionsFrom}
                      </select>
                      <span className='filterYearSeparator'>{t('filters.and')}</span>
                      <select id='flightYearTo' defaultValue={year_to || 'default'} onChange={this.onChangeFormField.bind(null, 'year_to')} style={{ minWidth: '80px', marginLeft: '10px' }}>
                        {optionsTo}
                      </select>
                    </td>
                  </tr>
                : null }
                { searchOption === 'cartografia-antigua' ?
                  <tr>
                    <td className='attribute-selector-field-title'>{'Periodos'}</td>
                    <td className='attribute-selector-field-value' style={{ display: 'flex', justifyContent: 'center' }}>
                      <div>
                        <div>
                          <CheckBox id={'century1'} onClick={this.selectCentury.bind(null, 'century1')} isSelected={centuries.indexOf('century1') > -1} />
                          <span>&nbsp;&nbsp;Siglo XVII</span>
                        </div>
                        <div>
                          <CheckBox id={'century3'} onClick={this.selectCentury.bind(null, 'century2')} isSelected={centuries.indexOf('century2') > -1} />
                          <span>&nbsp;&nbsp;Siglo XVIII</span>
                        </div>
                        <div>
                          <CheckBox id={'century3'} onClick={this.selectCentury.bind(null, 'century3')} isSelected={centuries.indexOf('century3') > -1} />
                          <span>&nbsp;&nbsp;Siglo XIX</span>
                        </div>
                        <div>
                          <CheckBox id={'century4'} onClick={this.selectCentury.bind(null, 'century4')} isSelected={centuries.indexOf('century4') > -1} />
                          <span>&nbsp;&nbsp;Siglo XX</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                : null }
                { searchOption !== 'cartografia-antigua' ?
                  <tr>
                    <td className='attribute-selector-field-title'>{'Colecciones'}</td>
                    <td className='attribute-selector-field-value' style={{ display: 'flex', justifyContent: 'center' }}>
                      <div>
                        { collectionsRows }
                      </div>
                    </td>
                  </tr>
                : null }
              </tbody>
            </table>
          </div>
          <div className='filtersButtonContainer row'>
            <Button text={t('filters.search')} number={1} active={true} onClick={this.search} />
            { searched ?
              <Button text={t('filters.clean')} number={2} active={true} onClick={this.clean} />
            : null }
          </div>
          <CustomModal open={open} onClose={this.handleClose} title={undefined}>
            { modalOption === 'error-loading' ?
              <Warning>
                <p style={{ width: '160px', textAlign: 'center' }}>{t('filters.load_error')}</p>
              </Warning>
            : null }
          </CustomModal>
        </div>
      </div>
    );
  }
}

export default translate()(Filters);
